import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {EntitlementsTab} from './entitliments-tab';

type Props = {
    accountId: number,
};

export const AccountEntitlementsSubTab = ({accountId}: Props) => (
    <>
        <EntitlementsTabBar
            accountId={accountId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.caption}/>
        </div>
        <EntitlementsTab key={accountId} accountId={accountId}/>
    </>
);
